export default "__VITE_ASSET__CHpwoZSr__"